import { BaseAction } from "../../../core/actions/BaseAction";
import { isEmpty } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { PriceInfo } from "../../../Orchestrator/Types/Types/TrainTypes";

export class StandardTrainSelectAction extends BaseAction<void, { priceInfo: PriceInfo }> {

    override async run(): Promise<void | null> {
        try {
            const { priceInfo } = this.params!;            
            const standardValueOfferId: string | null = priceInfo.standardValue.offerId || null;
            const standardValueProOfferId: string | null = priceInfo.standardPro.offerId || null;
            const shuttleValueOfferId: string | null = priceInfo.shuttle?.offerId || null;

            if (!isEmpty(standardValueOfferId)) {
                updateRecoilState<string | null>(
                    "selectedOfferIdAtom",
                    standardValueOfferId
                );
                //onSelect("standardValue");
            } else if (!isEmpty(standardValueProOfferId)) {
                updateRecoilState<string | null>(
                    "selectedOfferIdAtom",
                    standardValueProOfferId
                );
                //onSelect("standardPro");
            }
            if (!isEmpty(standardValueOfferId) || !isEmpty(standardValueProOfferId)) {
                //setPrivacySeating(false);
                //setPrivacyPremuimSeating(false);
                //updateRecoilState("dateState", startDate);
            }

            if (!isEmpty(shuttleValueOfferId)) {
                updateRecoilState<string | null>(
                    "selectedShuttleOfferIdAtom",
                    shuttleValueOfferId
                );
            }

        } catch (error) {
            console.error("Error in StandardTrainSelectAction:", error);
        }
    }
}

// Create a singleton instance
export const standardTrainSelectAction = new StandardTrainSelectAction(); 